import "../CSS/kontakt.css";


function KontaktPage() {

    return (
        <>

            <div className="intro">

                <h1>
                    Kontakt zu IRJ-Tantramassagen
                </h1>

                <p>
                    Du möchtest mehr über meine Tantramassagen erfahren
                    oder einen Termin vereinbaren? Du kannst mich auf
                    folgenden Kanälen erreichen.
                </p>

            </div>


            <main className="kontakt-main">

                <section className="kontakt">

                    <h2>
                        Kontaktmöglichkeiten
                    </h2>

                    <p>
                        Ich bin Ivan von IRJ-Tantramassagen im
                        Sarganserland. Mein Angebot richtet sich auch
                        an Menschen aus Mels, Sargans, Bad Ragaz und
                        der umliegenden Region.
                    </p>


                    <div className="kontakt-tabelle-container">

                        <table className="kontakt-tabelle">

                            <thead>

                                <tr>

                                    <th>
                                        Kontaktmöglichkeit
                                    </th>

                                    <th>
                                        Angabe
                                    </th>

                                    <th>
                                        Priorität
                                    </th>

                                </tr>

                            </thead>


                            <tbody>

                                <tr>

                                    <td>
                                        WhatsApp
                                        (Text oder Sprachnachricht)
                                    </td>

                                    <td>

                                        <a
                                            href="https://wa.me/41767174121"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            076 717 41 21
                                        </a>

                                    </td>

                                    <td className="prio-sehr-hoch">
                                        1
                                    </td>

                                </tr>


                                <tr>

                                    <td>
                                        Telegram
                                    </td>

                                    <td>

                                        <a
                                            href="https://t.me/irj_tantramassagen"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            irj_tantramassagen
                                        </a>

                                    </td>

                                    <td className="prio-niedrig">
                                        2
                                    </td>

                                </tr>


                                <tr>

                                    <td>
                                        Telefon
                                    </td>

                                    <td>

                                        <a href="tel:+41767174121">
                                            076 717 41 21
                                        </a>

                                    </td>

                                    <td className="prio-hoch">
                                        2
                                    </td>

                                </tr>


                                <tr>

                                    <td>
                                        E-Mail
                                    </td>

                                    <td>

                                        <a href="mailto:ivan@irj-tantramassagen.ch">
                                            ivan@irj-tantramassagen.ch
                                        </a>

                                    </td>

                                    <td className="prio-mittel">
                                        3
                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                </section>

            </main>

        </>
    );
}


export default KontaktPage;